class mobileMenu{
    constructor(mobileButtonClass, mobileButtonToggleClass, mobileNavigation, mobileNavigationToggleClass) {
        this.mobileMenuButton = document.querySelector(`.${mobileButtonClass}`)
        this.mobileMenuButtonToggleClass = mobileButtonToggleClass
        this.mobileNavigation = document.querySelector(`.${mobileNavigation}`)
        this.mobileNavigationToggleClass = mobileNavigationToggleClass
        this.isMobileMenuOpen = false
    }
    _setUpEventListeners() {
        this.mobileMenuButton.addEventListener('click', () => this._toggleMobileMenu())
    }
    _toggleMobileMenu() {
        this.isMobileMenuOpen = !this.isMobileMenuOpen
        document.querySelector('body').classList.toggle('m-overflow-hidden')
        document.querySelector('.c-header__primary').classList.toggle('c-header__primary--m-active')
        document.querySelector('.hamburger').classList.toggle('is-active')
        this.mobileNavigation.classList.toggle(this.mobileNavigationToggleClass)
        this.mobileMenuButton.classList.toggle(this.mobileMenuButtonToggleClass)
        if(this.isMobileMenuOpen) {
            this.mobileMenuButton.setAttribute('aria-expanded', true)
        }
        else {
            this.mobileMenuButton.setAttribute('aria-expanded', false)
        }
    }
    init() {
        if(this.mobileMenuButton != null) {
            this._setUpEventListeners()
        }
    }
}

export default mobileMenu